import { Injectable } from '@angular/core';
import { Response, Headers, RequestOptions } from '@angular/http';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from './sxHttp.service';
import { CacheService } from './cache.service';
import { SxSecurityService } from './sxSecurity.service';
import { SxSubscription } from '../model/classes/subscription.class';
import { SxTranslationService } from './translation-service.service';

const serviceUrl = "api/configuracionSubscriptions";

@Injectable()
export class SubscriptionsService {
  constructor(private sxHttp: SxHttpService,
    private sxTranslationService: SxTranslationService,
    private cacheService: CacheService) { }


  getOptions(organizationCode:string,subscriptionCode:string):Observable<ItemGeneralListado[]>
  {
    const url = `${serviceUrl}/GetOptions/${organizationCode}/${subscriptionCode}`;

    return this.sxHttp.get(url)
    .map(response => {
      return response.json().data
        .map(comando => {
          return {
            id: comando.codComando,
            Titulo: this.sxTranslationService.getResource(comando.codComando),
            Descripcion: this.sxTranslationService.getResource(comando.descripcion),
            Imagen: comando.icon,
            UrlDestination: comando.urlDestination
          };
        }) as ItemGeneralListado[];
    });
  }

  getByOrganization(organizationCode:string , state: string = null): Observable<SxSubscription[]> {
    const search = {};

    if (state) {
      search['state'] = state;
      search['withImage'] = false;
    }
    
    return this.sxHttp
      .get(`${serviceUrl}/GetAll/${organizationCode}`, search)
      .map(response => response.json().data as SxSubscription[]);
  }

  getSubscriptions(estado: string = null): Observable<SxSubscription[]> {
    const search = {};

    if (estado) {
      search['estado'] = estado;
      search['withImage'] = false;
    }

    return this.sxHttp
      .get('api/configuracionSubscriptions/', search)
      .map(response => response.json().data as SxSubscription[]);
  }

  /**
   * Return a subscription from backend
   * @param codigo the subscription code to look for
   */
  getSubscription(organizationCode:string, subscriptionCode: string): Observable<SxSubscription> {
    return this.sxHttp
      .get('api/configuracionSubscriptions/' + organizationCode + '/' + subscriptionCode)
      .map(result => result.json().data as SxSubscription);
  }

  /**
   * Create a New Subscription
   *
   * @param subscriptionCode Subscription Code for new Subscription
   * @param organizationCode Organizacition Code for new Subscription
   */
  crearDesdeUnCodigo(subscriptionCode: string, organizationCode: string): Promise<any> {
   const newSubscription: SxSubscription = {
      subscriptionCode: subscriptionCode,
      descripcion: 'Enter the name of the Subscription',
      organizationCode: organizationCode
    };

    return this.sxHttp
      .post('api/configuracionSubscriptions/', newSubscription)
      .toPromise()
      .then(result => {
        const res = result.json().data as SxSubscription;
      });
  }

  /**
   * Edit an existing subscription to the backend
   */
  editSubscription(organizationCode: string, subscriptionCode: string, data: any): Promise<SxSubscription> {
    delete data['completitud'];
    return this.sxHttp
      .put('api/configuracionSubscriptions/' + organizationCode + '/' + subscriptionCode, data)
      .toPromise()
      .then(response =>
        response.json().data as SxSubscription
      );
  }

  /**
   * Delete existing subscription to the backend
   */
  deleteSubscription(organizationCode: string, subscriptionCode: string): Observable<any> {
    return this.sxHttp
      .delete(`api/configuracionSubscriptions/` + organizationCode + '/' + subscriptionCode)
      .map(result => result.json().data);
  }

  /**
   * Get the subscriptions list from backend and map it
   * to a compatible format for the General Listing component
   */
  getForList(): Observable<ItemGeneralListado[]> {
    const search = {};
    search['withImage'] = true;
    return this.sxHttp.get('api/configuracionSubscriptions/', search).map(response => {
      return response.json().data.map(subscription => {
        return {
          id: subscription.subscriptionCode,
          Titulo: subscription.descripcion,
          Descripcion: subscription.descripcionExt,
          Imagen: subscription.urlImage
        };
      }) as ItemGeneralListado[];
    });
  }

  /**
   * Active an existing subscription to the backend
   */
  activar(organizationCode: string, subscriptionCode: string): Promise<SxSubscription> {
    const url = `api/configuracionSubscriptions/` + organizationCode + '/' + subscriptionCode + `/activar`;
    return this.sxHttp
      .put(url, null)
      .toPromise()
      .then(response => response.json().data as SxSubscription);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/subscriptions.service.ts